/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export type ClickSelectDatesParams = Record<string, never>;

/**
 * 発火タイミング：Select Datesボタン押下時
 */
export const sendGAWabunkaClickSelectDatesEvent = () => {
  sendWabunkaGAEvent('click_select_dates', {});
};
